// extracted by mini-css-extract-plugin
module.exports = {"item":"Card_item__2nSKz","icon":"Card_icon__EqhOQ","imageWrapper":"Card_imageWrapper__i_uYJ","circle":"Card_circle__vNwF5","full":"Card_full__dqLB_","text":"Card_text___ATa8"};